<template>
  <div class="inline-eta">
    <div class="upper-eta">
      <div
        class="eta"
      >{{ etaValue(0) }}
      </div>
    </div>
    <div
      v-if="lowerEtaDisplayed()"
      class="lower-eta"
    >
      <div class="eta">
        {{ etaValue(1) }}
      </div>
      <div class="eta">
        {{ etaValue(2) }}
      </div>
    </div>
  </div>
</template>

<script>
import {queryStringBuilder, ROUTE_STOP_DETAILS} from "../../config/paths/apiPaths";
import etaParse from "../../utils/etaParse";

export default {
  name: "GetEta",
  props: ['stopDetails'],
  data() {
    return {
      eta: [],
    };
  },
  methods: {
    // todo: to centralize ETA getting APIs
    async getEta() {
      const {routeid, routedir, stopseq} = this.stopDetails;
      const stopDetailsParams = {
        routeid, routedir, stopseq
      };

      const response = await fetch(`${ROUTE_STOP_DETAILS}?${queryStringBuilder(stopDetailsParams)}`);
      const json = await response.json();

      if (json.data) {
        const {company} = json.data;

        if (json.data.eta) {
          this.eta = etaParse(company, json.data.eta);
        }
      }

    },

    lowerEtaDisplayed() {
      return true;
    },

    etaValue(i) {
      console.log(this.eta);

      return this.eta[i] ? this.eta[i].time : "--";
    },

  },
  mounted() {
    this.getEta();
  }
}
</script>

<style scoped>
.eta {
  color: rgb(243, 69, 69);
}

.eta-notes {
  font-size: 0.85em;
}

.upper-eta {
  font-size: 1.2em;
}

.upper-eta > div {
  text-align: center;
}

.lower-eta > div {
  display: inline-block;
  width: 45%;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}
</style>
